import { QueryClient } from '@tanstack/react-query'
import {
    ACTION_HISTORY_QUERY_POLICY,
    ANSWER_ENTITY_QUERY_POLICY,
    QUEST_ENTITY_QUERY_POLICY,
    RANKED_STREAM_QUERY_LIFECYCLE_POLICY,
    QUEST_STREAM_QUERY_POLICY,
    STREAMS_QUERY_POLICY,
    USER_ENTITY_QUERY_POLICY,
} from 'api/queryPolicies'

declare global {
    interface Window {
        queryClient: QueryClient
    }
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            gcTime: Infinity,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            structuralSharing: false,
            networkMode: 'always',
        },
    },
})

queryClient.setQueryDefaults(['quests'], {
    staleTime: QUEST_STREAM_QUERY_POLICY.staleTime,
    gcTime: QUEST_STREAM_QUERY_POLICY.gcTime,
})
queryClient.setQueryDefaults(['ordinalsMediaStream'], {
    staleTime: QUEST_STREAM_QUERY_POLICY.staleTime,
    gcTime: QUEST_STREAM_QUERY_POLICY.gcTime,
    ...RANKED_STREAM_QUERY_LIFECYCLE_POLICY,
})
queryClient.setQueryDefaults(['quest'], QUEST_ENTITY_QUERY_POLICY)
queryClient.setQueryDefaults(['answer'], ANSWER_ENTITY_QUERY_POLICY)
queryClient.setQueryDefaults(['user'], USER_ENTITY_QUERY_POLICY)
queryClient.setQueryDefaults(['userNorm'], USER_ENTITY_QUERY_POLICY)
queryClient.setQueryDefaults(['actions'], {
    staleTime: ACTION_HISTORY_QUERY_POLICY.staleTime,
    gcTime: ACTION_HISTORY_QUERY_POLICY.gcTime,
})
queryClient.setQueryDefaults(['streams'], {
    staleTime: STREAMS_QUERY_POLICY.staleTime,
    gcTime: STREAMS_QUERY_POLICY.gcTime,
})
if (typeof window !== 'undefined') window.queryClient = queryClient

export default queryClient
